import { useCompanyId } from 'application/providers/AccountProvider';

import useAcceptanceAdvancedStartSigning from 'domain/billing/useAcceptanceAdvancedStartSigning';

interface AcceptanceAdvancedModalViewModel {
  startSigningAcceptanceAdvancedLoading: boolean;
  handleRedirectToAcceptanceAdvanced: () => Promise<void>;
}

interface Props {
  pathname: string;
  showStartSigningErrorNotification: () => void;
}

const IS_SHOW_CREATE_POINT_MODAL_KEY = 'IS_SHOW_CREATE_POINT_MODAL';

const useAcceptanceAdvancedModalViewModel = ({
  pathname,
  showStartSigningErrorNotification,
}: Props): AcceptanceAdvancedModalViewModel => {
  const companyId = useCompanyId();

  const { request, loading: startSigningAcceptanceAdvancedLoading } = useAcceptanceAdvancedStartSigning();

  const handleRedirectToAcceptanceAdvanced = async () => {
    const link = await request({ companyId, uriForReturn: `${window.location.origin}${pathname}` });

    if (link) {
      localStorage.setItem(IS_SHOW_CREATE_POINT_MODAL_KEY, 'true');
      window.location.assign(link);
    } else {
      showStartSigningErrorNotification();
    }
  };

  return {
    handleRedirectToAcceptanceAdvanced,
    startSigningAcceptanceAdvancedLoading,
  };
};

export default useAcceptanceAdvancedModalViewModel;
